import { useState } from "react";

export function useDragUpload({ onUpload = () => {} }: { onUpload?: (files: File[]) => void } = {}) {
  const [isDragActive, setIsDragActive] = useState(false);

  function handleDragEnter() {
    setIsDragActive(true);
  }

  function handleDragLeave(e: React.DragEvent) {
    // Check if the drag leave event is triggered by leaving the drop zone
    if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget as Node)) {
      return;
    }
    setIsDragActive(false);
  }

  /**
   * Required to allow dropping files
   */
  function handleDragOver(e: React.DragEvent) {
    e.preventDefault();
    e.stopPropagation();
  }

  function handleDrop(e: React.DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);

    // Check if files are dropped
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const file = e.dataTransfer.files[0];
      onUpload([file]);
    }
  }

  const dragUploadProps = {
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
  };

  return { isDragActive, dragUploadProps };
}
